
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"32","height":"32","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none"}},[_c('path',{attrs:{"fill":"currentColor","fill-opacity":".16","d":"M4.929 19.071l.707-3.535 9.192-9.193 2.829 2.829-9.193 9.192z"}}),_c('path',{attrs:{"stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-miterlimit":"10","stroke-width":"1.5","d":"M14.828 6.343l2.829 2.829m.566-5.091l1.697 1.697a.8.8 0 010 1.13L8.464 18.365l-3.535.707.707-3.535L17.091 4.08a.8.8 0 011.132 0"}})])])
          )
        }
      }
    